const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const elements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (!elements.length) return;

  if (isDesignModeEvent || reduceMotion.matches) {
    elements.forEach((element) => {
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      if (isDesignModeEvent) element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, index) => {
        const target = entry.target;
        if (!entry.isIntersecting) {
          target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
          target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
          return;
        }
        target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (target.hasAttribute('data-cascade')) target.style.setProperty('--animation-order', index);
        observer.unobserve(target);
      });
    },
    { rootMargin: '0px 0px -32px 0px' }
  );

  elements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  // Continuous scroll-linked zoom is intentionally disabled for touch/coarse pointers and reduced motion.
  if (reduceMotion.matches || window.matchMedia('(pointer: coarse)').matches) return;

  const elements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  if (!elements.length) return;

  const visible = new Set();
  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
  });
  elements.forEach((element) => visibilityObserver.observe(element));

  let ticking = false;
  const update = () => {
    ticking = false;
    const viewportHeight = window.innerHeight;
    visible.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const distance = viewportHeight - rect.top;
      const percentage = Math.max(0, Math.min(100, Math.round((distance / (viewportHeight + rect.height)) * 100)));
      element.style.setProperty('--zoom-in-ratio', 1 + (0.2 / 100) * percentage);
    });
  };
  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  requestUpdate();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
}

window.addEventListener(
  'DOMContentLoaded',
  () => {
    initializeScrollAnimationTrigger();
    initializeScrollZoomAnimationTrigger();
  },
  { once: true }
);

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
